import css from '@styled-system/css';
import { useCombobox } from 'downshift';
import React, { forwardRef } from 'react';
import { usePopper } from 'react-popper';
import styled from 'styled-components';
import theme from '../theme';
import Box from './Box';
import List from './List';
import ListItem from './ListItem';
const StyledList = styled(List) `
  width: -moz-available;
  width: -webkit-fill-available;
  ${css({
    bg: 'white',
    borderColor: 'gray.5',
    borderRadius: '1',
    borderStyle: 'solid',
    borderWidth: '1',
    boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
    cursor: 'default',
    maxHeight: '180px',
    my: '1',
    overflow: 'auto'
})}
  &:focus {
    ${css({
    outline: '0'
})}
  }
`;
const StyledListItem = styled(ListItem) `
  padding-left: 8px;
  padding-right: 8px;
  &[aria-selected='true'] {
    ${css({
    backgroundColor: 'gray.6'
})}
  }
`;
const Autocomplete = forwardRef(({ value, onChange, id, options, getOptionLabel, renderInput, renderOption: renderOptionProp, openOnFocus }, ref) => {
    const [inputItems, setInputItems] = React.useState(options);
    const { isOpen, 
    // TODO: We should expose the labelProps
    // getLabelProps,
    getMenuProps, getItemProps, getInputProps, getComboboxProps, openMenu } = useCombobox({
        items: inputItems,
        itemToString: getOptionLabel,
        selectedItem: value,
        onSelectedItemChange: onChange,
        onInputValueChange: ({ inputValue }) => {
            setInputItems(options.filter(item => getOptionLabel(item)
                .toLowerCase()
                .startsWith(inputValue ? inputValue.toLowerCase() : '')));
        }
    });
    const [referenceElement, setReferenceElement] = React.useState(null);
    const [popperElement, setPopperElement] = React.useState(null);
    const { styles, attributes } = usePopper(referenceElement, popperElement, {
        placement: 'bottom-start'
    });
    const menuProps = getMenuProps();
    const menuRef = (ref) => {
        setPopperElement(ref);
        menuProps.ref(ref);
    };
    const renderOption = renderOptionProp || getOptionLabel;
    return (React.createElement(Box, Object.assign({ id: id, width: 'fit-content' }, getComboboxProps()),
        React.createElement("div", { ref: setReferenceElement }, renderInput(getInputProps({
            ref: ref,
            onFocus: openOnFocus ? openMenu : undefined
        }))),
        React.createElement("div", Object.assign({}, menuProps, { ref: menuRef, style: Object.assign(Object.assign({}, styles.popper), { width: referenceElement ? referenceElement.clientWidth : undefined }) }, attributes.popper), isOpen && (React.createElement(StyledList, Object.assign({ bg: 'gray.6' }, getMenuProps()), inputItems.map((option, index) => (React.createElement(StyledListItem, Object.assign({ key: index }, getItemProps({ item: option, index })), renderOption(option)))))))));
});
Autocomplete.defaultProps = {
    theme,
    getOptionLabel: (x) => x
};
Autocomplete.displayName = 'Autocomplete';
export default Autocomplete;
//# sourceMappingURL=Autocomplete.js.map